import { List } from 'immutable';
import { createSelector } from 'reselect';

import { ASSET_TYPE } from '../assets/reducers';
import { getTaskAssets } from 'phoenix2/state/content/selectors';
import { selectCurrentViewType } from '../views/selectors';
import { VIEW_STATES_KEY } from './reducers';

export const getViewState = (state, viewId) => state.getIn([VIEW_STATES_KEY, viewId]);

export const getViewStateFilter = (state, viewId) =>
    state.getIn([VIEW_STATES_KEY, viewId, 'filter']);

export const makeGetJSViewState = () =>
    createSelector([getViewState], viewState => viewState && viewState.toJS());

export const getCurrentTaskId = state => {
    const viewState = getViewState(state, 'task');
    return viewState && viewState.get('taskId');
};

export const getCurrentTaskClosed = state => {
    const viewState = getViewState(state, 'task');
    return viewState && viewState.get('closed', false);
};

const getCurrentTaskAssets = state => {
    const taskId = getCurrentTaskId(state);
    return taskId && getTaskAssets(state, taskId);
};

export const getAssetQueue = createSelector(
    getCurrentTaskAssets,
    selectCurrentViewType,
    (taskAssets, currentView) => {
        if (!taskAssets || !currentView) {
            return List();
        }

        // Create a list of assetId, assetType pairs for the question images.
        const questionImageIds = taskAssets.get('question');
        const questionImagePairs = [];
        for (const imageId of questionImageIds) {
            questionImagePairs.push({
                assetId: imageId,
                assetType: ASSET_TYPE.IMAGE,
            });
        }
        // Create a list of assetId, assetType pairs for the video posters.
        const videoImageIds = taskAssets.get('video');
        const videoImagePairs = [];
        for (const imageId of videoImageIds) {
            videoImagePairs.push({
                assetId: imageId,
                assetType: ASSET_TYPE.POSTER,
            });
        }

        // Preload the question images first if we're in the task view and
        // preload the video posters first if we're in the skill delivery view.
        switch (currentView) {
            case 'task':
                return questionImagePairs.concat(videoImagePairs);
            case 'skilldelivery':
                return videoImagePairs.concat(questionImagePairs);
        }
        return List();
    },
);

/*
    Returns any data cached by the game before transitioning away from the
    screen. Used at the start of games (e.g. Auto Hi-Lo, Find It) to check if
    the player was interrupted mid-game, and if so, the game should load into
    a midway-through-play state (to prevent cheating)
 */
export const getResumeState = (state, viewId) =>
    state.getIn([VIEW_STATES_KEY, viewId, 'resumeState']);

export const getMostRecentTaskItemId = state =>
    state.getIn([VIEW_STATES_KEY, 'task', 'mostRecentTaskItemId'], '');

export const getMostRecentTaskItemStatus = state =>
    state.getIn([VIEW_STATES_KEY, 'task', 'mostRecentTaskItemStatus'], '');
